export default "__VITE_ASSET__Czg$Lc0c__"